export default function AboutProgram() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 
      bg-gradient-to-b from-[#F8FAFC] via-white to-[#F1F5F9] overflow-hidden">

      {/* subtle background accent */}
      <div className="absolute top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] 
        bg-[#0E6F7E]/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="bg-white/80 backdrop-blur-xl rounded-2xl 
          shadow-[0_20px_60px_rgba(2,8,23,0.08)] 
          px-8 md:px-12 py-14 md:py-16 animate-fade-up">

          <div className="text-center mb-12">
            <div className="inline-block">
              <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#07162E] mb-6">
                About the Program
              </h2>
            </div>
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
            <p>
              This exclusive Partner Program and Masterclass is designed for
              investment professionals, financial advisors, and capital market
              intermediaries who aspire to build structured, compliant, and
              scalable relationships with institutional capital ecosystems.
            </p>

            <p>
              The program focuses on empowering professionals with the knowledge,
              frameworks, and institutional alignment necessary to facilitate
              capital raising, investor servicing, and long-term fund execution
              in a governance-driven environment.
            </p>

            <p>
              Participants will gain deep insights into investment structuring,
              regulatory compliance, capital market readiness, and the
              operational dynamics of institutional fund management. This is not
              just a training program—it is a gateway to becoming a trusted
              partner in the capital deployment ecosystem.
            </p>

            <p className="font-semibold text-[#07162E] border-l-4 border-[#0E6F7E] pl-4">
              By the end of this program, participants will understand how to
              align their professional practice with institutional standards,
              access structured partnership opportunities, and contribute
              meaningfully to the growth of capital market infrastructure.
            </p>
          </div>
        </div>
      </div>

      {/* animation */}
      <style>{`
        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-up {
          animation: fadeUp 1s ease-out both;
        }
      `}</style>
    </section>
  );
}
